<template>
  <section class="section-reset-password">
    <div class="section-login container">
      <div class="section-reset-password-inner">
        <b-img
          :src="`${publicPath}assets/images/trebel_logo.png`"
          class="trebel-logo mb-4"
          alt="Trebel"
        ></b-img>
        <form @submit.prevent="resetPassword">
            <h3 class="reset-password-title">{{ $t("resetPassword") }}</h3>
            <p class="reset-password-text">{{ $t("resetPasswordText")}} {{ $route.query.email }}</p>
            <div 
              class="form-control-icon-wrap input-field-floating mb-3 d-flex-icons"
            >
                <b-form-input
                class="input-field-floating"
                :type="showNewPassword ? 'text' : 'password'"
                v-model="password"
                placeholder=""
                name="password"
                :data-vv-as="$t('password')"
                :class="{
                  'error-input': this.error.message,
                  'valid-input': !this.error.message.length && password
                }"
                @input="checkValidation(), removeErrorMessage()"
                ></b-form-input>
                <label> {{ $t("password") }}</label>
            </div>
            <div class="form-control-icon-wrap input-field-floating mb-3 d-flex-icons">
                <b-form-input
                class="input-field-floating"
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="confirmPassword"
                placeholder=""
                name="confirmPassword"
                :data-vv-as="$t('password')"
                :class="{
                  'error-input': this.error.message,
                  'valid-input': !this.error.message.length && confirmPassword
                }"
                @input="checkValidation(), removeErrorMessage()"
                ></b-form-input>
                <label> {{ $t("confirmPassword") }}</label>
            </div>
            
            <div v-if="error.message" class="invalid-field mb-3">
                {{ error.message }}
            </div>
            <b-button type="submit" :variant="btnClass" block class="btn-login mb-3">
                {{ $t("resetPassword") }}
            </b-button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from '../i18n';

export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      showNewPassword: false,
      showConfirmPassword: false,
      credentials: {
        token: this.$route.query.token,
      },
      error: {
        message: ""
      },
      btnClass: "gray"
    };
  },
  mounted() {
    if (
      !this.$route.query.token || 
      !this.$route.query.token.length
    ) {
      window.location = "https://home.trebel.io"
    }
  },
  methods: {
    checkValidation() {
        if (this.password.length > 5 && this.confirmPassword.length > 5) {
            this.btnClass = "yellow";
        }        
    },
    removeErrorMessage() {
        this.error.message = "";
    },
    resetPassword() {
        if (!this.$route.query.token) {
            return;
        }
        if (this.password !== this.confirmPassword) {
            this.error.message = i18n.t('eerorMessgaePasswordNotMutch');
            return;
        }
        if (this.password === this.confirmPassword && this.password.length < 6) {
            this.error.message = i18n.t('errorMessageShortPassword');
            return;
        }
        this.credentials.password = this.password;
        this.$store
          .dispatch("resetPassword", this.credentials)
          .then(() => {
            this.$router.push({
                name: "Success",
                query: { type: 'reset'}
            });
          })
          .catch(error => {
            this.error.message = error.response.data.error.message;
          });
    }
  }
};
</script>

<style scoped>
 .d-flex-icons {
  display: flex;
  align-items: center;
  justify-content: end;
 }

 .cursor-pointer {
  cursor: pointer;
 }
</style>